<div class="wo-labelled-field" [class.wo-labelled-field--horizontal]="horizontal">
  <div
    class="wo-labelled-field-label"
    [class.wo-labelled-field-label--reversed]="reversed"
    [class.wo-labelled-field-label--bold]="bold"
  >{{ label }}<ng-content select="[woLabelledFieldLabel]"/></div>
  <!--  DO NOT ADD WHITESPACES BETWEEN following div because if computed expression is falsy-->
  <!--  then special :empty element is added to render inner N/A value -->
  <div
    class="wo-labelled-field-data"
    [class.wo-labelled-field-data--important]="important"
    [class.wo-labelled-field-data--reversed]="reversed"
    [class.wo-labelled-field-data--bold]="bold"
    [class.wo-labelled-field-data--no-wrap]="noWrap"
    [class.wo-labelled-field--link]="link"
    [routerLink]="link"
  >{{ value }}<ng-content/></div>
</div>
